<template>
	<div style="display: flex; flex-direction: column; width: 100%;">
		
		<div v-if="content1" style="background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; flex-direction: column; margin-top: 15px; display: flex; width: 100%;">
			<div style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">{{ this.$props.data.text == '帮我解读“当日需及时关心的长者”' ? '好的，以下是今日“需及时关心”的长者清单：' : (this.$props.data.text ? this.$props.data.text : (this.$props.data.title ? this.$props.data.title : '')) }} </div>
			</div>
			<div style="height: 1px; background: rgba(31, 38, 53, 0.1); margin-left: 20px; margin-right: 20px;"></div>
			<div class="markdownContent" style="padding-left: 35px; padding-right: 35px; margin-top: 15px; margin-bottom: 10px;">
				<div class="markdownContent" v-html="content1"></div>
			</div>
		</div>
		<div v-if="!content1" style="background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; flex-direction: column; margin-top: 15px; display: flex; width: 100%;">
			<div style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">{{ this.$props.data.text == '帮我解读“当日需及时关心的长者”' ? '好的，以下是今日“需及时关心”的长者清单：' : (this.$props.data.text ? this.$props.data.text : (this.$props.data.title ? this.$props.data.title : '')) }} </div>
			</div>
			<div style="height: 1px; background: rgba(31, 38, 53, 0.1); margin-left: 20px; margin-right: 20px;"></div>
			
			<div class="markdownContent" style="margin-top: 15px; margin-bottom: 10px; background: rgba(94, 103, 121, 0.05); margin-left: 20px; margin-right: 20px; border-radius: 8px; margin-bottom: 0px;">
				<div style="display: flex; justify-content: space-between; align-items: center; height: 40px; cursor: pointer;" @click="clickUnflod()">
					<div style="display: flex; align-items: center;">
						<img style="width: 16px; height: 16px; cursor: pointer; margin-left: 15px;" src="../../assets/icon_ai_depth_icon_1.png" alt="" />
						<div style="margin-left: 4px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ '已深度思考' }}</div>
					</div>
					<img v-if="!isUnfold" style="width: 24px; height: 24px; cursor: pointer; margin-right: 15px;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false" />
					<img v-if="isUnfold"  style="width: 24px; height: 24px; cursor: pointer; margin-right: 15px;" src="../../assets/icon_home_ai_icon_3_2.png" alt="" draggable="false" />
				</div>
				<div v-if="isUnfold" class="markdownContent" v-html="content2" style="margin-left: 35px; margin-right: 15px; margin-top: 12px; color: rgba(94, 103, 121, 0.5); font-size: 12px; line-height: 17px;"></div>
			</div>
			
			<div class="markdownContent" style="padding-left: 35px; padding-right: 35px; margin-top: 15px; margin-bottom: 10px;">
				<div class="markdownContent" v-html="content3"></div>
			</div>
		</div>
		<div v-if="isLoading" style="display: flex;  height: 120px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; margin-top: 15px; overflow: hidden;" v-loading="isLoading" element-loading-text="AI分析中，请稍候..." class="loadingContent"></div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
import axios from 'axios';

export default {
	props: {
		data: {
			type: Object,
			default: null
		},
		dataIndex: {
			type: Number,
			default: null
		},
	},
	computed: {
	},
	watch: {
		
	},
	data() {
		return {


			rawContent: '',
			displayedContent: '',

			isLoading: false,

			
			content1: null,

			content2: null,
			content3: null,
			
			isUnfold: false

		};
	},
	created() {
	},
	mounted() {
		this.$nextTick(() => {
			let content = this.$props.data.content || '';
			marked.use({
				mangle: false,
				headerIds: false
			});
			let markdownStr = content ? content : '';
			let needStr = markdownStr || '';
			// 将小波浪号替换为大波浪号,解决删除线的问题
			let newNeedStr = needStr.replace(/~/g, "～")

			this.rawContent = this.rawContent + '\n\n' + newNeedStr || '';
			this.displayedContent = marked(this.rawContent);


			if (this.displayedContent.indexOf('QingleiSplitThought') >= 0) {
				let tempArr = this.displayedContent.split('QingleiSplitThought');
				this.content2 = tempArr[0];
				this.content3 = tempArr[1];
			} else {
				this.content1 = this.displayedContent;
			}
		})
	},
	methods: {
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		}
	},
};
</script>
<style lang="scss" scoped>

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -35px !important;
	}
}

</style>